"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _commons = require("egov-ui-kit/utils/commons");

var _components = require("components");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _utils = require("egov-ui-kit/redux/app/utils");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _PropertyInfoCard = require("../PropertyInfoCard");

var _PropertyInfoCard2 = _interopRequireDefault(_PropertyInfoCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = (0, _localStorageUtils.getLocale)() || "en_IN";
// import { connect } from "react-redux";

var localizationLabelsData = (0, _utils.initLocalizationLabels)(locale);

// const getAddressItems = (addressObj) => {
//   return (
//     addressObj && [
//       // {
//       //   // heading: getTranslatedLabel("PT_PROPERTY_ADDRESS_SUB_HEADER", localizationLabelsData),
//       //   // // iconAction: "action",
//       //   // iconName: "home",
//       //   items: [
//       {
//         key: getTranslatedLabel("PT_PROPERTY_ADDRESS_CITY", localizationLabelsData),
//         value: addressObj.city || "NA",
//       },
//       {
//         key: getTranslatedLabel("PT_PROPERTY_ADDRESS_HOUSE_NO", localizationLabelsData),
//         value: addressObj.doorNo || "NA",
//       },
//       {
//         key: getTranslatedLabel("PT_PROPERTY_ADDRESS_COLONY_NAME", localizationLabelsData),
//         value: addressObj.buildingName || "NA",
//       },
//       {
//         key: getTranslatedLabel("PT_PROPERTY_ADDRESS_STREET_NAME", localizationLabelsData),
//         value: addressObj.street || "NA",
//       },
//       {
//         key: getTranslatedLabel("PT_PROPERTY_ADDRESS_MOHALLA", localizationLabelsData),
//         value: addressObj.locality.name || "NA",
//       },
//       {
//         key: getTranslatedLabel("PT_PROPERTY_ADDRESS_PINCODE", localizationLabelsData),
//         value: addressObj.pincode || "NA",
//       },

//       //   ],
//       // },
//     ]
//   );
// };
var transform = function transform(floor, key, generalMDMSDataById, propertyDetails) {
  var propertySubType = propertyDetails.propertySubType,
      usageCategoryMajor = propertyDetails.usageCategoryMajor;
  var masterName = key.masterName,
      dataKey = key.dataKey;

  if (!masterName) {
    return floor["occupancyType"] === "RENTED" ? "INR " + floor["arv"] : Math.round(floor[dataKey] * 100) / 100 + " sq yards";
  } else {
    if (floor[dataKey]) {
      if (dataKey === "usageCategoryDetail") {
        return generalMDMSDataById["UsageCategoryDetail"] ? generalMDMSDataById["UsageCategoryDetail"][floor[dataKey]].name : generalMDMSDataById["UsageCategorySubMinor"] ? generalMDMSDataById["UsageCategorySubMinor"][floor["usageCategorySubMinor"]].name : "NA";
      }
      // if (usageCategoryMajor === "RESIDENTIAL" && propertySubType === "SHAREDPROPERTY" && dataKey === "floorNo") {
      //   return "NA";
      // }
      if (floor[dataKey] === "NONRESIDENTIAL") {
        return generalMDMSDataById["UsageCategoryMinor"] ? generalMDMSDataById["UsageCategoryMinor"][floor["usageCategoryMinor"]].name : "NA";
      } else {
        return generalMDMSDataById[masterName] ? generalMDMSDataById[masterName][floor[dataKey]].name : "NA";
      }
    } else {
      return "NA";
    }
  }
};
// const getAssessmentInfo = (propertyDetails, keys=[], generalMDMSDataById) => {
//     const { units } = propertyDetails || {};

//     return (
//       propertyDetails && [
//         {
//           heading: getTranslatedLabel("PT_ASSESMENT_INFO_SUB_HEADER", localizationLabelsData),
//           iconAction: "action",
//           iconName: "assignment",
//           showTable: true,
//           tableHeaderItems: [
//             {
//               key: getTranslatedLabel("PT_ASSESMENT_INFO_USAGE_TYPE", localizationLabelsData),
//               value: propertyDetails.usageCategoryMajor ? propertyDetails.usageCategoryMajor : "NA", //noOfFloors
//             },
//             {
//               key: getTranslatedLabel("PT_ASSESMENT_INFO_TYPE_OF_BUILDING", localizationLabelsData),
//               value: generalMDMSDataById
//                 ? propertyDetails.propertySubType
//                   ? generalMDMSDataById["PropertySubType"]
//                     ? generalMDMSDataById["PropertySubType"][propertyDetails.propertySubType].name
//                     : "NA"
//                   : generalMDMSDataById["PropertyType"]
//                     ? generalMDMSDataById["PropertyType"][propertyDetails.propertyType].name
//                     : "NA"
//                 : "NA",
//             },
//             {
//               key: getTranslatedLabel("PT_ASSESMENT_INFO_PLOT_SIZE", localizationLabelsData),
//               value:
//                 propertyDetails.propertySubType === "SHAREDPROPERTY"
//                   ? "NA"
//                   : propertyDetails.uom
//                     ? `${propertyDetails.landArea} ${propertyDetails.uom}`
//                     : `${Math.round(propertyDetails.landArea * 100) / 100} sq yards`,
//             },
//             {
//               key: getTranslatedLabel("PT_ASSESMENT_INFO_NO_OF_FLOOR", localizationLabelsData),
//               value: propertyDetails.noOfFloors ? `${propertyDetails.noOfFloors}` : "NA", //noOfFloors
//             },
//           ],
//           items: {
//             header: units
//               ? [
//                 getTranslatedLabel("PT_ASSESMENT_INFO_FLOOR", localizationLabelsData),
//                 getTranslatedLabel("PT_ASSESMENT_INFO_USAGE_TYPE", localizationLabelsData),
//                 // getTranslatedLabel("PT_ASSESMENT_INFO_SUB_USAGE_TYPE", localizationLabelsData),
//                 getTranslatedLabel("PT_ASSESMENT_INFO_OCCUPLANCY", localizationLabelsData),
//                 getTranslatedLabel("PT_ASSESMENT_INFO_AREA_RENT", localizationLabelsData),
//               ]
//               : [],
//             values: units
//               ? units.map((floor) => {
//                 return {
//                   value: keys.map((key) => {
//                     return transform(floor, key, generalMDMSDataById, propertyDetails);
//                   }),
//                 };
//               })
//               : [],
//           },
//         },
//       ]
//     );
//   };
var getAssessmentInfo = function getAssessmentInfo(propertyDetails, generalMDMSDataById) {
  var _ref = propertyDetails || {},
      _ref$units = _ref.units,
      units = _ref$units === undefined ? [] : _ref$units,
      noOfFloors = _ref.noOfFloors;

  return propertyDetails && [{
    key: (0, _commons.getTranslatedLabel)("PT_ASSESMENT_INFO_USAGE_TYPE", localizationLabelsData),
    value: propertyDetails.usageCategoryMajor ? 'PROPERTYTAX_BILLING_SLAB_' + propertyDetails.usageCategoryMajor : "NA" //noOfFloors
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_ASSESMENT_INFO_TYPE_OF_BUILDING", localizationLabelsData),
    value: generalMDMSDataById ? propertyDetails.propertySubType ? generalMDMSDataById["PropertySubType"] ? generalMDMSDataById["PropertySubType"][propertyDetails.propertySubType].name : "NA" : generalMDMSDataById["PropertyType"] ? generalMDMSDataById["PropertyType"][propertyDetails.propertyType].name : "NA" : "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_ASSESMENT_INFO_PLOT_SIZE", localizationLabelsData),
    value: propertyDetails.propertySubType === "SHAREDPROPERTY" ? "NA" : propertyDetails.uom ? propertyDetails.landArea + " " + propertyDetails.uom : Math.round(propertyDetails.landArea * 100) / 100 + " sq yards"
  }, propertyDetails.propertySubType === "SHAREDPROPERTY" ? {
    key: (0, _commons.getTranslatedLabel)("PT_FLOOR_NO", localizationLabelsData),
    value: units.length > 0 ? "" + units[0].floorNo : "NA"
  } : {
    key: (0, _commons.getTranslatedLabel)("PT_ASSESMENT_INFO_NO_OF_FLOOR", localizationLabelsData),
    value: noOfFloors ? "" + noOfFloors : "NA" //noOfFloors
  }];
};

var getUnitInfo = function getUnitInfo() {
  var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  units = units || [];
  var floors = [];
  units.map(function (unit, index) {
    if (unit) {
      var floor = [{
        key: (0, _commons.getTranslatedLabel)("PT_ASSESSMENT_UNIT_USAGE_TYPE", localizationLabelsData),
        value: unit.usageCategoryMinor ? 'PROPERTYTAX_BILLING_SLAB_' + unit.usageCategoryMinor : unit.usageCategoryMajor ? 'PROPERTYTAX_BILLING_SLAB_' + unit.usageCategoryMajor : "NA"
      }, {

        key: (0, _commons.getTranslatedLabel)("PT_ASSESMENT_INFO_OCCUPLANCY", localizationLabelsData),
        value: unit.occupancyType ? 'PROPERTYTAX_OCCUPANCYTYPE_' + unit.occupancyType : "NA"
      }, {

        key: (0, _commons.getTranslatedLabel)("PT_FORM2_BUILT_AREA", localizationLabelsData),
        value: unit.unitArea ? unit.unitArea + '' : "NA"
      }];
      if (unit.occupancyType === "RENTED") {
        floor.push({
          key: (0, _commons.getTranslatedLabel)("PT_FORM2_TOTAL_ANNUAL_RENT", localizationLabelsData),
          value: unit.arv ? unit.arv + '' : "NA"
        });
      }
      if (!floors[unit['floorNo']]) {
        floors[unit['floorNo']] = [floor];
      } else {
        floors[unit['floorNo']].push(floor);
      }
    }
  });
  return floors;
};

var AssessmentInfo = function AssessmentInfo(_ref2) {
  var properties = _ref2.properties,
      editIcon = _ref2.editIcon,
      generalMDMSDataById = _ref2.generalMDMSDataById;

  var hideSubsectionLabel = false;
  var assessmentItems = [];
  var subUnitItems = [];
  var header = 'PT_ASSESMENT_INFO_SUB_HEADER';
  if (properties) {
    var propertyDetails = properties.propertyDetails;

    if (propertyDetails && propertyDetails.length > 0) {
      subUnitItems = getUnitInfo(propertyDetails[0]['units']);
      assessmentItems = getAssessmentInfo(propertyDetails[0], generalMDMSDataById);
      if (propertyDetails[0].propertySubType === "SHAREDPROPERTY") {
        hideSubsectionLabel = true;
      }
    }
  }

  return _react2.default.createElement(_PropertyInfoCard2.default, { editIcon: editIcon, items: assessmentItems, header: header, subSection: subUnitItems, hideSubsectionLabel: hideSubsectionLabel });
};

exports.default = AssessmentInfo;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/propertyTax/Property/components/AssessmentInfo/index.js
// module id = 2278
// module chunks = 1143